import React from 'react';
import PropTypes from 'prop-types';
import { CCard, CCardBody, CCardGroup } from '@coreui/react';

const Cards = ({ children }) => {
  return (
    <CCardGroup>
      <CCard className="CustomCard">
        <CCardBody>{children}</CCardBody>
      </CCard>
    </CCardGroup>
  );
};

Cards.propTypes = {
  children: PropTypes.element.isRequired
};

export default Cards;
